<template>
  <v-container>
    <v-flex class="flex">
      <v-layout>
        <v-card class="masterCard">
          <v-flex style="padding-left: 10%">
            <v-col>
              <v-row>
                <v-icon>mdi-account</v-icon>
                <v-card-title id="userNameTxt">
                  <v-text-field
                    v-model="user.userName"
                    label="Nombre de usuario"
                  ></v-text-field>
                </v-card-title>

                <v-card-title id="userNameTxt">
                  <v-text-field
                    v-model="organizationName"
                    label="Organización"
                  ></v-text-field>
                </v-card-title>
                <v-card-title id="userNameTxt">
                  <v-text-field
                    v-model="user.email"
                    label="email"
                  ></v-text-field>
                </v-card-title>
                <v-card-title>
                  <!-- stop prop prevent to trigget the click row event -->

                  <v-switch
                    v-model="user.enabled"
                    @click.stop="toggleUser(user.id, user.enabled)"
                  >
                  </v-switch>
                </v-card-title>
                <v-card-title>
                  <v-icon @click.stop="deleteUser(user.id)">mdi-delete</v-icon>
                </v-card-title>
              </v-row>
              <v-row>
                <v-card-title id="userNameTxt">
                  <v-text-field
                    v-model="user.password"
                    label="Contraseña"
                    type="password"
                  ></v-text-field>
                </v-card-title>
              </v-row>
            </v-col>
          </v-flex>

          <v-simple-table style="width: 100%">
            <template v-slot:top>
              <v-toolbar flat>
                <v-dialog max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn style="max-width: 150px" v-bind="attrs" v-on="on"
                      >Agregar rol</v-btn
                    >
                  </template>
                  <v-card>
                    <v-col cols="12" sm="12" md="12">
                      <v-autocomplete
                        :items="roles"
                        label="Seleccione un rol"
                        v-model="updateRole"
                      ></v-autocomplete>
                    </v-col>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="addPermissionToUser(updateRole)"
                        >Agregar</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>

            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Rol</th>
                  <th style="text-left">Permisos</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in user.UserRoles" :key="item.id">
                  <td>{{ item.role.name }}</td>
                  <td>
                    <v-row>
                      <v-main
                        v-for="permissions in item.role.permissions"
                        :key="permissions.id"
                        >{{ permissions.permission.name }}</v-main
                      >

                      <v-icon @click="removeRoleToUser(item.id, item.role.name)"
                        >mdi-delete</v-icon
                      >
                    </v-row>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-layout>
    </v-flex>
  </v-container>
</template>

<script>
import {
  GetUser,
  getCookie,
  disableUser,
  enableUser,
  editUser,
  GetAllRoles,
  addRole,
  removeRole,
} from "@/utils/apiRequest.js";
export default {
  data() {
    return {
      user: Object,
      organizationName: "",
      updateRole: "",
      roles: [],
    };
  },
  async mounted() {
    var cookie = getCookie("jwt");
    if (!cookie) {
      this.$router.set("/");
    }
    let response = await GetUser(this.$route.params.id);
    if (response.data.status == "success") {
      this.user = response.data.user;
      this.organizationName = this.user.organization.name;
    }
    response = await GetAllRoles();
    if (response.data.status == "success") {
      response.data.roles.forEach((roles) => {
        this.roles.push(roles.name);
      });
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    async enableUser(userID) {
      var updatedUser = await enableUser(userID);
      if (updatedUser.data.status) {
        window.location.reload();
      }
    },
    async disableUser(userID) {
      var updatedUser = await disableUser(userID);
      if (updatedUser.data.status) {
        window.location.reload();
      }
    },

    enable(status) {
      if (!status) {
        return true;
      }
      return false;
    },
    disable(status) {
      if (status) {
        return true;
      }
      return false;
    },
    async toggleUser(orgID, enable) {
      if (enable) {
        await this.enableUser(orgID);
        return;
      }
      await this.disableUser(orgID);
    },
    async addPermissionToUser(rol) {
      var updatedUser = await addRole(this.user.id, rol);
      if (updatedUser.data.status) {
        window.location.reload();
      }
    },
    async removeRoleToUser(roldID, rol) {
      var updatedUser = await removeRole(roldID, this.user.id, rol);
      if (updatedUser.data.status != "failure") {
        window.location.reload();
      }
    },
    async save() {
      let user = {
        id: this.editedItem.id,
        username: this.editedItem.userName,
        password: this.editedItem.password,
        enabled: this.editedItem.enabled,
        roles: [
          {
            roleID: this.editedItem.role,
          },
        ],
        email: this.editedItem.email,
        organizationName: this.editedItem.organizationID,
      };
      let updatedUser = await editUser(this.editedItem.id, user);
      if (updatedUser.data.status == "success") {
        this.edited = false;
        window.location.reload();
        this.close();
      }
    },
  },
};
</script>
<style scoped>
.flex {
  align-items: center;
  align-content: center;
  align-self: center;
}
.masterCard {
  align-self: center;
  margin: 0 auto;
}
#userNameTxt {
  min-width: 100px;
  width: 25%;
  max-width: 200px;
}
</style>